import { USA_STATES } from "@src/appV2/lib/utils";
import { Button } from "@src/appV2/redesign/components/Button";
import { type WorkerRequirement } from "@src/appV2/redesign/Documents/api/types";
import { DOCUMENT_DETAILS_FULL_PATH } from "@src/appV2/redesign/Documents/paths";
import { type MissingCredentialType } from "@src/appV2/redesign/Documents/types";
import { generatePath } from "react-router-dom";

import { ShiftBottomSheetBookabilityCriteriaCard } from "../BookabilityCriteriaCard";

interface MissingCredentialCardContentProps {
  missingCredentialRequirement: WorkerRequirement;
  missingCredentialType: MissingCredentialType;
  shiftQualification: string;
  workplaceState?: string;
}
export function MissingCredentialCardContent(props: MissingCredentialCardContentProps) {
  const {
    missingCredentialRequirement,
    missingCredentialType,
    shiftQualification,
    workplaceState,
  } = props;

  const stateAbbreviation = workplaceState
    ? USA_STATES.find((state) => state.name === workplaceState)?.key
    : undefined;

  const documentDescriptionLabel =
    missingCredentialRequirement?.requirement?.attributes.name ?? "valid qualification";

  const description =
    missingCredentialType === "BASE_CREDENTIAL"
      ? `You need a ${documentDescriptionLabel} to book ${shiftQualification} shifts${
          workplaceState ? ` in the state of ${workplaceState}` : ""
        }.`
      : `You need a ${documentDescriptionLabel} to book this shift.`;

  const href = generatePath(DOCUMENT_DETAILS_FULL_PATH, {
    requirementId: missingCredentialRequirement.requirementId,
  });

  return (
    <ShiftBottomSheetBookabilityCriteriaCard
      title={`Upload ${
        missingCredentialType === "BASE_CREDENTIAL" ? `${stateAbbreviation} State ` : ""
      }Qualification`}
      description={description}
      illustrationType="document-upload"
      footer={
        <Button fullWidth href={href} variant="contained" size="medium">
          Upload
        </Button>
      }
    />
  );
}
